import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseProductCluster() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      title: isEmpty(state.title),
    };

    setter(errorState);

    if (errorState.title) {
      enqueueSnackbar("لطفا اطلاعات خوشه محصول را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const getclusterList = (myPC, search, callback, bool) => {
    MyAxios.get(`Admin_Productcluster?w=${search}`, {
      headers: {
        IsPage: bool,
        Conditions: JSON.stringify({ pageCondition: myPC }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getAllClusterList = (callback) => {
    MyAxios.get(`Admin_Productcluster?w=`, {
      headers: {
        Conditions: JSON.stringify({
          pageCondition: {
            page: 1,
            pageCount: 1,
            sortColumn: "Id",
            sortOrder: "Asc",
          },
        }),
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getclusterByID = (id, callback) => {
    MyAxios.get(`Admin_Productcluster/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getclusterSortlist = (callback) => {
    MyAxios.get(`Admin_Productcluster/sortlist`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const updatecluster = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("خوشه محصول با موفقیت ادیت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addcluster = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("خوشه محصول با موفقیت اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const deletecluster = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Productcluster`, { data: data }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("خوشه محصول با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const addclusterCategory = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/Category`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("دسته خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addclusterBrand = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/Brand`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("برند خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addclusterGroup = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/Group`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("گروه خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addclusterProduct = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/Product`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("محصول خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addclusterCountry = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/Country`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کشور خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addclusterColor = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/Color`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("رنگ خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addclusterIngredient = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/Ingredient`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("ترکیبات خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addclusterProductType = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/ProductType`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("نوع محصول خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const addclusterTargetLocation = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/Item/TargetLocation`, data, {}).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("محل مصرف خوشه با موفقیت اضافه شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const deleteclusterItem = (id, callback) => {
    const data = new FormData();
    data.append("ID", id);
    MyAxios.delete(`Admin_Productcluster/Item`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar(" با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  const ActiveCluster = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/active`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const SuspendCluster = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_Productcluster/suspend`, data, {}).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت انجام شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const getResultByID = (id, callback) => {
    MyAxios.get(`Admin_Productcluster/search/${id}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  return {
    getclusterList,
    getclusterByID,
    getAllClusterList,
    validate,
    updatecluster,
    addcluster,
    deletecluster,
    addclusterCategory,
    addclusterBrand,
    addclusterGroup,
    addclusterProduct,
    deleteclusterItem,
    ActiveCluster,
    getclusterSortlist,
    addclusterCountry,
    addclusterColor,
    addclusterIngredient,
    addclusterProductType,
    addclusterTargetLocation,
    getResultByID,
    SuspendCluster,
  };
}
